import React, { useCallback, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {useMutation, useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { CONST_REGEX_MOBILE } from "../../services/common/Constants";
import { NOJOOM_OOREDOOREWARD_ITEMLIST_URL } from "../../services/common/endpoints";
import { GetCacheKey } from "../../services/common/utils";
import Loadingcomponent from "../loader/loadingcomponent";
import { callQueryapi } from '../../services/http/callapi';
const GiftAnotherNumberModal = (props) => {
  // const toggleModal = props.toggleModal()

  const { t } = useTranslation();
  const navigate = useNavigate();
  const [error, seterror] = useState(false);
  const [numbers, setNumbers] = useState("");
  const ChangeHandler = (e) => {
    e.target.value = e.target.value.slice(0, 8);
    e.target.value = e.target.value.replace(CONST_REGEX_MOBILE);
    setNumbers({ ...numbers, msisdn: "965" + e.target.value });
    console.log(e.target.value, "valierjw");
    if (e.target.value?.length !== 8) {
      seterror(t("peavmn"));
    } else {
      seterror("");
    }
  };

  console.log(props, "numbers")
  const verifyMsisdn = useMutation(
    req =>
      callQueryapi({
        queryKey: [
          GetCacheKey("OOREDOOREWARDS_MOBILE_VALIDATION"),
          'nojoom/telcoproducts',
          {
            category: '',
            tomsisdn: req,
            type: 'rn',
          },
        ],
      }),
    {
      onSuccess: (udata, variables, context) => {
        if (udata?.data?.status === '0') {
          // onContinuePressed(contactNumber);
          props.name === "ViewAll"
          ? navigate("/ooredeorewards-home", {
            state: {
              msisdn: props?.data, giftnumber: numbers?.msisdn
            }
          })
            : navigate(`/ooredeorewards-viewall/${props.category}`, {
              state:  numbers.msisdn 
            });
        } else {
          seterror(udata?.data?.message);
        }
      },
      onError: (uerror, variables, context) => {
        seterror(t('unable'));
      },
    }
  );
  const submitVoucher = () => {
    if (numbers === "") {
      seterror(t('peavmn'));
    } else if (
      props?.data === numbers?.msisdn
    ) {
      seterror(t('giftyou'));
    } else {
      verifyMsisdn.mutate(numbers?.msisdn);
      // onContinuePressed(contactNumber);
    }
  };

  const params = {
    category: "",
    tomsisdn: numbers?.msisdn,
    type: "rn",
  };
  const {
    data: { data } = {},
    isLoading,
    isFetching,
    isError,
    isLoadingError,
    refetch,
  } = useQuery(
    [
      GetCacheKey("Gift_Number"),
      NOJOOM_OOREDOOREWARD_ITEMLIST_URL.url,
      params,
      {},
    ],
    {
      retry: false,
      retryOnMount: false,
      enabled: false,
    }
  );
  useEffect(() => {
    if (data?.status === "-1") {
      seterror(data?.message);
    } else if (data?.status === "0") {
      props.name === "ViewAll"
      ? navigate("/ooredeorewards-home", {
        state: {
          msisdn: props?.data, giftnumber: numbers?.msisdn
        }
      })
        : navigate(`/ooredeorewards-viewall/${props.category}`, {
          state: {
            msisdn: props?.data, giftnumber: numbers?.msisdn
          }
          });
      seterror("");
    }
  }, [data]);

  return (
    <Modal
      show={props.show}
      backdrop="static"
      className="full_modal animated  slideInRight faster position-fixed overflow-hidden"
    >
      <Modal.Header>
        <button className="modal_close" onClick={() => props.toggleModal()}>
          <img
            src={process.env.PUBLIC_URL + "/assets/images/cross_dark.svg"}
            alt=""
            title=""
          />
        </button>
      </Modal.Header>
      <Modal.Body className="">
        <h2 class="mb-2 page_title_v1">{t("gtan")}</h2>
        <p class="support_text mb-0">
          <span dir="ltr">{t("sgasyfaf")}</span>
        </p>

        <div className="recharge_sec overflow-auto mb-5 pb-5">
          <div class="form-group mb-4 mt-5">
            <label class="control-label">{t("mobilenumber")}</label>
            <div class="input_icon right-icon">
              <input
                type="number"
                pattern="\d*"
                maxlength="8"
                name="msisdn"
                onWheel={(event) => event.currentTarget.blur() }
                onKeyDown={ 
                  (evt) => 
                  (evt.key === 'e' || evt.key === '.') && 
                  evt.preventDefault() }
                onChange={(e) => {
                  ChangeHandler(e);
                }}
                class="form-control"
                placeholder={t("mobile_number")}
              />
            </div>
            {error && <p className="text-danger">{error}</p>}
          </div>

          <div className="text-center mt-5">
            <button
              className={`custom_btn custom_btn_primary btn_block ${
                verifyMsisdn?.isLoading && "disabled"
              }`}
              onClick={verifyMsisdn?.isLoading ? () => {} : submitVoucher}
            >
              {verifyMsisdn?.isLoading ? (
                <Loadingcomponent message={"Loading"} />
              ) : (
                t("continue")
              )}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default GiftAnotherNumberModal;
